import { useState } from "react";
import { Area, AreaChart, CartesianGrid, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { usePoll, Panel } from "@/components/common";
import { fmtTime } from "@/lib/api";

const RANGES = [[1, "1h"], [6, "6h"], [24, "24h"], [168, "7d"]];

export function RangePicker({ value, onChange, testid }) {
  return (
    <div className="flex gap-1" data-testid={testid}>
      {RANGES.map(([h, l]) => (
        <button key={h} data-testid={`${testid}-${l}`} onClick={() => onChange(h)}
          className={`px-2 py-0.5 rounded text-[11px] font-mono transition-colors ${value === h ? "bg-cyan-500/20 text-cyan-300" : "text-slate-500 hover:text-slate-200"}`}>{l}</button>
      ))}
    </div>
  );
}

function Chart({ data, series, fmt, cap, capLabel, hours }) {
  return (
    <ResponsiveContainer width="100%" height={170}>
      <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <CartesianGrid stroke="#1E293B" strokeDasharray="3 3" />
        <XAxis dataKey="ts" tick={{ fill: "#64748B", fontSize: 10 }} tickFormatter={(t) => fmtTime(t, hours > 24).slice(0, hours > 24 ? 12 : 5)} minTickGap={40} />
        <YAxis tick={{ fill: "#64748B", fontSize: 10 }} tickFormatter={fmt} width={64} domain={[0, (max) => Math.max(max, cap || 0) * 1.1 || 1]} />
        <Tooltip contentStyle={{ background: "#16202E", border: "1px solid #334155", fontSize: 11 }} labelFormatter={(t) => fmtTime(t, true)} formatter={(v, n) => [fmt(v), n]} />
        {series.map(([k, c, n]) => <Area key={k} name={n} type="monotone" dataKey={k} stroke={c} fill={c} fillOpacity={0.12} strokeWidth={1.5} isAnimationActive={false} />)}
        {cap > 0 && <ReferenceLine y={cap} stroke="#EF4444" strokeDasharray="4 4" label={{ value: capLabel, fill: "#EF4444", fontSize: 10, position: "insideTopRight" }} />}
      </AreaChart>
    </ResponsiveContainer>
  );
}

export function UsageCharts({ kind, refId, charts, testid }) {
  const [hours, setHours] = useState(6);
  const { data } = usePoll(`/admin/usage?kind=${kind}&ref=${refId}&hours=${hours}`, 30000);
  const empty = data && data.length === 0;
  return (
    <Panel title="Usage history" testid={testid} right={<RangePicker value={hours} onChange={setHours} testid={`${testid}-range`} />}>
      {empty ? <p className="text-sm text-slate-500">Collecting data — the first points appear within a minute (one point per minute, kept 30 days).</p> : (
        <div className={`grid gap-4 ${charts.length > 1 ? "xl:grid-cols-2" : ""}`}>
          {charts.map((c) => (
            <div key={c.title}>
              <div className="text-[10px] font-semibold uppercase tracking-wider text-slate-500 mb-1">{c.title}</div>
              <Chart data={data || []} hours={hours} {...c} />
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
